import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { useGetData, usePostData } from "services/sales"
import { isBefore } from "utils/date"
import { handleResponse } from "utils/fetch"

export const PAYMENT_TYPE_ONLINE_CREDIT_CARD = 1
export const PAYMENT_TYPE_CREDIT_CARD_CASH = 2
export const PAYMENT_TYPE_LOAN = 3
export const PAYMENT_TYPE_RECEIVABLES = 4
export const PAYMENT_TYPE_QRPAY = 5
export const PAYMENT_TYPE_GOGORO_WALLET = 6
export const UNEDITABLE_PAYMENT_TYPES = [PAYMENT_TYPE_ONLINE_CREDIT_CARD, PAYMENT_TYPE_QRPAY]

export const LOAN_TYPE_NORMAL = 1
export const LOAN_TYPE_FULL_AMOUNT = 2
export const LOAN_TYPE_STUDENT = 3
export const LOAN_TYPE_TWO_STEPS = 4
export const LOAN_TYPE_NO_INTEREST = 5
export const LOAN_TYPE_PROMOTION = 6
export const NO_DOWN_PAYMENT_LOAN_TYPE = [LOAN_TYPE_FULL_AMOUNT, LOAN_TYPE_NO_INTEREST, LOAN_TYPE_PROMOTION]

export const SPECIAL_LOAN_INSTALLMENT = 899

export const HALF_LOAN_PLAN_PERIOD_INDEX = 40
// 24期 真零利率
export const NO_INTEREST_LOAN_PLAN_TWENTY_FOUR_PERIOD_INDEX = 43
// 36期 真零利率
export const NO_INTEREST_LOAN_PLAN_PERIOD_INDEX = 45
// 學生利率
export const REAL_NO_INTEREST_LOAN_PLAN_PERIOD_INDEX = 60

export const VEHICLE_LOANS_INDEXES = [
  NO_INTEREST_LOAN_PLAN_TWENTY_FOUR_PERIOD_INDEX,
  NO_INTEREST_LOAN_PLAN_PERIOD_INDEX,
  REAL_NO_INTEREST_LOAN_PLAN_PERIOD_INDEX,
]

export const ES_PLAN_FIXED_AMOUNT_OPTION_1 = 6000
export const ES_PLAN_FIXED_AMOUNT_OPTION_2 = 9000
export const ACCESSORY_ESPLAN_LOAN_AMOUNT_LIMIT = 12000 // 配件資費貸款金額上限

export const LOAN_COMPANY_LIST = {
  80607612: {
    loanNoPattern: /(^(FT|GT)[0-9A-Za-z]{8})/i,
    length: 11,
    name: "遠信",
  },
  70774816: {
    loanNoPattern: /(^\d{4}A[0-9]{7})/i,
    length: 12,
    name: "仲信",
  },
  16844548: {
    loanNoPattern: /^[A-Za-z0-9]{10}$/i,
    length: 10,
    name: "和潤",
  },
  27615281: {
    loanNoPattern: /(^\d{6}[A-Za-z]\d{5}$)/i,
    length: 12,
    name: "長鴻",
  },
  80659759: {
    loanNoPattern: /(^(M|N)[A-Za-z]\d{11}$)/i,
    length: 13,
    name: "裕富",
  },
  80503378: {
    loanNoPattern: /(^(Fulaweb)\d{8}[0-9A-Za-z]{5})/i,
    length: 20,
    name: "中信",
  },
}

export const periodBanksMap = {
  // 12: undefined,
  12: ["017", "822", "012", "808", "810", "081", "812", "007", "805", "803"],
  18: ["808"],
  24: ["017"].concat(new Date().getFullYear() >= 2022 ? "812" : "822"),
  30: ["017"],
}

export const creditCardPromotions = !isBefore(new Date(), new Date("2023-10-01T00:00"))
  ? [
      {
        bank: "兆豐",
        card: "Gogoro 聯名卡",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "單筆分期滿 3 萬送",
            highlight: "300 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 2000 份",
        link: "//promotion.gogoro.com/tw/megabank-co-brand-card-interest-free-2019/",
        limit: 2000,
        eventCode: "EVT801",
      },
      {
        bank: "星展",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "單筆分期滿 1.5 萬送",
            highlight: "200 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 500 份",
        link: "//promotion.gogoro.com/tw/dbs-bank-promotion/",
        limit: 500,
        eventCode: "EVT917",
      },
      {
        bank: "星展",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "單筆分期滿 3 萬送",
            highlight: "500 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 200 份",
        link: "//promotion.gogoro.com/tw/dbs-bank-promotion/",
        limit: 200,
        eventCode: "EVT918",
      },
      {
        bank: "星展",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "單筆分期滿 5 萬送",
            highlight: "850 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 120 份",
        link: "//promotion.gogoro.com/tw/dbs-bank-promotion/",
        limit: 120,
        eventCode: "EVT919",
      },
      {
        bank: "星展",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "單筆分期滿 7 萬送",
            highlight: "1200 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 100 份",
        link: "//promotion.gogoro.com/tw/dbs-bank-promotion/",
        limit: 100,
        eventCode: "EVT920",
      },
      {
        bank: "第一銀行",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "單筆分期滿 6 萬送",
            highlight: "800 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 100 份",
        link: "//promotion.gogoro.com/tw/firstbank-promotion/",
        limit: 100,
        eventCode: "EVT750",
      },
      {
        bank: "第一銀行",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "單筆分期滿 8 萬送",
            highlight: "1000 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 100 份",
        link: "//promotion.gogoro.com/tw/firstbank-promotion/",
        limit: 100,
        eventCode: "EVT751",
      },
      {
        bank: "中信",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "單筆分期滿 5 千送",
            highlight: "100 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 300 份",
        link: "//promotion.gogoro.com/tw/china-trust-promotion/",
        limit: 300,
        eventCode: "EVT788",
      },
      {
        bank: "中信",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "單筆分期滿 1 萬送",
            highlight: "220 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 600 份",
        link: "//promotion.gogoro.com/tw/china-trust-promotion/",
        limit: 600,
        eventCode: "EVT789",
      },
      {
        bank: "中信",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "單筆分期滿 3 萬送",
            highlight: "680 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 450 份",
        link: "//promotion.gogoro.com/tw/china-trust-promotion/",
        limit: 450,
        eventCode: "EVT790",
      },
      {
        bank: "中信",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "單筆分期滿 5 萬送",
            highlight: "1150 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 480 份",
        link: "//promotion.gogoro.com/tw/china-trust-promotion/",
        limit: 480,
        eventCode: "EVT791",
      },
      {
        bank: "中信",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "單筆分期滿 8 萬送",
            highlight: "2000 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 480 份",
        link: "//promotion.gogoro.com/tw/china-trust-promotion/",
        limit: 480,
        eventCode: "EVT792",
      },
      {
        bank: "遠東",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "單筆分期滿 5 萬送",
            highlight: "700 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 300 份",
        link: "https://promotion.gogoro.com/tw/fareastern-bank-promotion/",
        limit: 300,
        eventCode: "EVT634",
      },
      {
        bank: "遠東",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "單筆分期滿 7 萬送",
            highlight: "1000 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 200 份",
        link: "//promotion.gogoro.com/tw/fareastern-bank-promotion/",
        limit: 200,
        eventCode: "EVT606",
      },
      {
        bank: "遠東",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "單筆分期滿 9 萬送",
            highlight: "1300 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 50 份",
        link: "//promotion.gogoro.com/tw/fareastern-bank-promotion/",
        limit: 50,
        eventCode: "EVT749",
      },
      {
        bank: "玉山",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "單筆分期滿 5 萬送",
            highlight: "700 元刷卡金",
            suffix: "",
          },
          {
            prefix: "單筆分期滿 8 萬 送",
            highlight: "1200 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 3000 份",
        link: "//promotion.gogoro.com/tw/esun-bank-promotion/",
        limit: 3000,
        eventCode: "EVT916",
      },
      {
        bank: "聯邦",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "單筆分期滿 5 萬送",
            highlight: "700 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 300 份",
        link: "//promotion.gogoro.com/tw/ubot-promotion/",
        limit: 300,
        eventCode: "EVT641",
      },
      {
        bank: "聯邦",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "單筆分期滿 8 萬送",
            highlight: "1200 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 200 份",
        link: "//promotion.gogoro.com/tw/ubot-promotion/",
        limit: 200,
        eventCode: "EVT642",
      },
      {
        bank: "花旗",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/05/31",
        text: [
          {
            prefix: "單筆分期滿 5 萬送",
            highlight: "700 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 400 份",
        link: "//promotion.gogoro.com/tw/citi-bank-promotion/",
        limit: 400,
        eventCode: "EVT694",
      },
      {
        bank: "花旗",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/05/31",
        text: [
          {
            prefix: "單筆分期滿 7 萬送",
            highlight: "900 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 200 份",
        link: "//promotion.gogoro.com/tw/citi-bank-promotion/",
        limit: 200,
        eventCode: "EVT695",
      },
      {
        bank: "匯豐",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "單筆分期滿 6 萬送",
            highlight: "750 元刷卡金",
            suffix: "",
          },
          {
            prefix: "單筆分期滿 10 萬送",
            highlight: "1500 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 1000 份",
        link: "//promotion.gogoro.com/tw/hsbc-promotion/",
        limit: 1000,
        eventCode: "EVT872",
      },
      {
        bank: "永豐",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "單筆分期滿 7 萬送",
            highlight: "900 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 150 份",
        link: "",
        limit: 150,
        eventCode: "EVT793",
      },
      {
        bank: "台新",
        card: "Gogoro 聯名卡",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2024/01/01",
        text: [
          {
            prefix: "購車享",
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "//promotion.gogoro.com/tw/taishin-bank-promotion/",
        limit: false,
        eventCode: "EVT740",
      },
      {
        bank: "台新",
        card: "Gogoro 聯名卡",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/01/01",
        text: [
          {
            prefix: "購車享",
            highlight: "24 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "//promotion.gogoro.com/tw/taishin-bank-promotion/",
        limit: false,
        eventCode: "EVT741",
      },
      {
        bank: "兆豐",
        card: "Gogoro 聯名卡",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            highlight: "30 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "//promotion.gogoro.com/tw/megabank-co-brand-card-interest-free-2019/",
        limit: false,
        eventCode: "EVT384",
      },
      {
        bank: "兆豐",
        card: "Gogoro 聯名卡",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            highlight: "24 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "//promotion.gogoro.com/tw/megabank-co-brand-card-interest-free-2019/",
        limit: false,
        eventCode: "EVT183",
      },
      {
        bank: "兆豐",
        card: "Gogoro 聯名卡",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "//promotion.gogoro.com/tw/megabank-co-brand-card-interest-free-2019/",
        limit: false,
        eventCode: "EVT149",
      },
      {
        bank: "台新",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "購車享",
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "//promotion.gogoro.com/tw/taishin-bank-promotion/",
        limit: false,
        eventCode: "EVT332",
      },
      {
        bank: "遠東",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "購車享",
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "//promotion.gogoro.com/tw/fareastern-bank-promotion/",
        limit: false,
        eventCode: "EVT604",
      },
      {
        bank: "玉山",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "購車享",
            highlight: "18 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "https://promotion.gogoro.com/tw/esun-bank-promotion/",
        limit: false,
        eventCode: "EVT795",
      },
      {
        bank: "玉山",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "購車享",
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "https://promotion.gogoro.com/tw/esun-bank-promotion/",
        limit: false,
        eventCode: "EVT222",
      },
      {
        bank: "富邦",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "購車享",
            highlight: "12 期 0 利率，Costco 聯名卡購車享最高5%好多金回饋",
            suffix: "",
          },
        ],
        remark: "",
        link: "https://promotion.gogoro.com/tw/fubon-bank-promotion/",
        limit: false,
        eventCode: "EVT192",
      },
      {
        bank: "星展",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "購車享",
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "https://promotion.gogoro.com/tw/dbs-bank-promotion/",
        limit: false,
        eventCode: "EVT259",
      },
      {
        bank: "第一銀行",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "購車享",
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "https://promotion.gogoro.com/tw/firstbank-promotion/",
        limit: false,
        eventCode: "EVT328",
      },
      {
        bank: "中信",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "購車享",
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "https://promotion.gogoro.com/tw/china-trust-promotion/",
        limit: false,
        eventCode: "EVT364",
      },
      {
        bank: "聯邦",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "購車享",
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "//promotion.gogoro.com/tw/ubot-promotion/",
        limit: false,
        eventCode: "EVT640",
      },
      {
        bank: "花旗",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/05/31",
        text: [
          {
            prefix: "購車享",
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "//promotion.gogoro.com/tw/citi-bank-promotion/",
        limit: false,
        eventCode: "EVT693",
      },
      {
        bank: "匯豐",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "購車享",
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "//promotion.gogoro.com/tw/hsbc-promotion/",
        limit: false,
        eventCode: "EVT752",
      },
      {
        bank: "永豐",
        showDate: true,
        startDate: "2023/10/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "購車享",
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "",
        limit: false,
        eventCode: "EVT796",
      },
    ]
  : [
      {
        bank: "兆豐",
        card: "Gogoro 聯名卡",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "單筆分期滿 3 萬送",
            highlight: "300 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 2000 份",
        link: "//promotion.gogoro.com/tw/megabank-co-brand-card-interest-free-2019/",
        limit: 2000,
        eventCode: "EVT801",
      },
      {
        bank: "星展",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "單筆分期滿 5 萬送",
            highlight: "700 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 100 份",
        link: "//promotion.gogoro.com/tw/dbs-bank-promotion/",
        limit: 100,
        eventCode: "EVT747",
      },
      {
        bank: "星展",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "單筆分期滿 7 萬送",
            highlight: "900 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 50 份",
        link: "//promotion.gogoro.com/tw/dbs-bank-promotion/",
        limit: 50,
        eventCode: "EVT748",
      },
      {
        bank: "星展",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "單筆分期滿 9 萬送",
            highlight: "1300 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 20 份",
        link: "//promotion.gogoro.com/tw/dbs-bank-promotion/",
        limit: 20,
        eventCode: "EVT794",
      },
      {
        bank: "第一銀行",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "單筆分期滿 6 萬送",
            highlight: "800 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 100 份",
        link: "//promotion.gogoro.com/tw/firstbank-promotion/",
        limit: 100,
        eventCode: "EVT750",
      },
      {
        bank: "第一銀行",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "單筆分期滿 8 萬送",
            highlight: "1000 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 100 份",
        link: "//promotion.gogoro.com/tw/firstbank-promotion/",
        limit: 100,
        eventCode: "EVT751",
      },
      {
        bank: "中信",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "單筆分期滿 5 千送",
            highlight: "100 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 900 份",
        link: "//promotion.gogoro.com/tw/china-trust-promotion/",
        limit: 900,
        eventCode: "EVT788",
      },
      {
        bank: "中信",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "單筆分期滿 1 萬送",
            highlight: "220 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 1000 份",
        link: "//promotion.gogoro.com/tw/china-trust-promotion/",
        limit: 1000,
        eventCode: "EVT789",
      },
      {
        bank: "中信",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "單筆分期滿 3 萬送",
            highlight: "680 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 400 份",
        link: "//promotion.gogoro.com/tw/china-trust-promotion/",
        limit: 400,
        eventCode: "EVT790",
      },
      {
        bank: "中信",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "單筆分期滿 5 萬送",
            highlight: "1150 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 330 份",
        link: "//promotion.gogoro.com/tw/china-trust-promotion/",
        limit: 330,
        eventCode: "EVT791",
      },
      {
        bank: "中信",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "單筆分期滿 8 萬送",
            highlight: "2000 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 330 份",
        link: "//promotion.gogoro.com/tw/china-trust-promotion/",
        limit: 330,
        eventCode: "EVT792",
      },
      {
        bank: "遠東",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "單筆分期滿 5 萬送",
            highlight: "700 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 300 份",
        link: "https://promotion.gogoro.com/tw/fareastern-bank-promotion/",
        limit: 300,
        eventCode: "EVT634",
      },
      {
        bank: "遠東",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "單筆分期滿 7 萬送",
            highlight: "1000 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 200 份",
        link: "//promotion.gogoro.com/tw/fareastern-bank-promotion/",
        limit: 200,
        eventCode: "EVT606",
      },
      {
        bank: "遠東",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "單筆分期滿 9 萬送",
            highlight: "1300 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 50 份",
        link: "//promotion.gogoro.com/tw/fareastern-bank-promotion/",
        limit: 50,
        eventCode: "EVT749",
      },
      {
        bank: "玉山",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "單筆分期滿 5 萬送",
            highlight: "900 元刷卡金",
            suffix: "",
          },
          {
            prefix: "單筆分期滿 8 萬 送",
            highlight: "1600 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 2000 份",
        link: "//promotion.gogoro.com/tw/esun-bank-promotion/",
        limit: 2000,
        eventCode: "EVT871",
      },
      {
        bank: "聯邦",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "單筆分期滿 5 萬送",
            highlight: "700 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 300 份",
        link: "//promotion.gogoro.com/tw/ubot-promotion/",
        limit: 300,
        eventCode: "EVT641",
      },
      {
        bank: "聯邦",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "單筆分期滿 8 萬送",
            highlight: "1200 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 200 份",
        link: "//promotion.gogoro.com/tw/ubot-promotion/",
        limit: 200,
        eventCode: "EVT642",
      },
      {
        bank: "花旗",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/05/31",
        text: [
          {
            prefix: "單筆分期滿 5 萬送",
            highlight: "700 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 400 份",
        link: "//promotion.gogoro.com/tw/citi-bank-promotion/",
        limit: 400,
        eventCode: "EVT694",
      },
      {
        bank: "花旗",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/05/31",
        text: [
          {
            prefix: "單筆分期滿 7 萬送",
            highlight: "900 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 200 份",
        link: "//promotion.gogoro.com/tw/citi-bank-promotion/",
        limit: 200,
        eventCode: "EVT695",
      },
      {
        bank: "匯豐",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "單筆分期滿 6 萬送",
            highlight: "750 元刷卡金",
            suffix: "",
          },
          {
            prefix: "單筆分期滿 10 萬送",
            highlight: "1500 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 1000 份",
        link: "//promotion.gogoro.com/tw/hsbc-promotion/",
        limit: 1000,
        eventCode: "EVT872",
      },
      {
        bank: "永豐",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "單筆分期滿 7 萬送",
            highlight: "900 元刷卡金",
            suffix: "",
          },
        ],
        remark: "需登錄，限量 150 份",
        link: "",
        limit: 150,
        eventCode: "EVT793",
      },
      {
        bank: "台新",
        card: "Gogoro 聯名卡",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "購車享",
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "//promotion.gogoro.com/tw/taishin-bank-promotion/",
        limit: false,
        eventCode: "EVT740",
      },
      {
        bank: "台新",
        card: "Gogoro 聯名卡",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "購車享",
            highlight: "24 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "//promotion.gogoro.com/tw/taishin-bank-promotion/",
        limit: false,
        eventCode: "EVT741",
      },
      {
        bank: "兆豐",
        card: "Gogoro 聯名卡",
        showDate: false,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            highlight: "30 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "//promotion.gogoro.com/tw/megabank-co-brand-card-interest-free-2019/",
        limit: false,
        eventCode: "EVT384",
      },
      {
        bank: "兆豐",
        card: "Gogoro 聯名卡",
        showDate: false,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            highlight: "24 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "//promotion.gogoro.com/tw/megabank-co-brand-card-interest-free-2019/",
        limit: false,
        eventCode: "EVT183",
      },
      {
        bank: "兆豐",
        card: "Gogoro 聯名卡",
        showDate: false,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "//promotion.gogoro.com/tw/megabank-co-brand-card-interest-free-2019/",
        limit: false,
        eventCode: "EVT149",
      },
      {
        bank: "台新",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "購車享",
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "//promotion.gogoro.com/tw/taishin-bank-promotion/",
        limit: false,
        eventCode: "EVT332",
      },
      {
        bank: "遠東",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "購車享",
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "//promotion.gogoro.com/tw/fareastern-bank-promotion/",
        limit: false,
        eventCode: "EVT604",
      },
      {
        bank: "玉山",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "購車享",
            highlight: "18 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "https://promotion.gogoro.com/tw/esun-bank-promotion/",
        limit: false,
        eventCode: "EVT795",
      },
      {
        bank: "玉山",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "購車享",
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "https://promotion.gogoro.com/tw/esun-bank-promotion/",
        limit: false,
        eventCode: "EVT222",
      },
      {
        bank: "富邦",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/12/31",
        text: [
          {
            prefix: "購車享",
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "https://promotion.gogoro.com/tw/fubon-bank-promotion/",
        limit: false,
        eventCode: "EVT192",
      },
      {
        bank: "星展",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "購車享",
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "https://promotion.gogoro.com/tw/dbs-bank-promotion/",
        limit: false,
        eventCode: "EVT259",
      },
      {
        bank: "第一銀行",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "購車享",
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "https://promotion.gogoro.com/tw/firstbank-promotion/",
        limit: false,
        eventCode: "EVT328",
      },
      {
        bank: "中信",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "購車享",
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "https://promotion.gogoro.com/tw/china-trust-promotion/",
        limit: false,
        eventCode: "EVT364",
      },
      {
        bank: "聯邦",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "購車享",
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "//promotion.gogoro.com/tw/ubot-promotion/",
        limit: false,
        eventCode: "EVT640",
      },
      {
        bank: "花旗",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/05/31",
        text: [
          {
            prefix: "購車享",
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "//promotion.gogoro.com/tw/citi-bank-promotion/",
        limit: false,
        eventCode: "EVT693",
      },
      {
        bank: "匯豐",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "購車享",
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "//promotion.gogoro.com/tw/hsbc-promotion/",
        limit: false,
        eventCode: "EVT752",
      },
      {
        bank: "永豐",
        showDate: true,
        startDate: "2023/07/01",
        endDate: "2023/09/30",
        text: [
          {
            prefix: "購車享",
            highlight: "12 期 0 利率",
            suffix: "",
          },
        ],
        remark: "",
        link: "",
        limit: false,
        eventCode: "EVT796",
      },
    ]

export const DEFAULT_DOCUMENT_FEE = 590
export const DEFAULT_LOAN_COMPANY_CODE = "16844548"
export const DOCUMENT_FEE_PRODUCT_NUMBER_300 = "GRS6B2-00026"
export const DOCUMENT_FEE_PRODUCT_NUMBER_400 = "GRS6B2-00060"
export const DOCUMENT_FEE_PRODUCT_NUMBER_590 = "GRS6B2-00069"
export const HANDLING_FEE_PRODUCT_NUMBER = "GRS6B2-00062"
export const LICENSE_SERVICE_FEE_PRODUCT_NUMBER = "GRS6B2-00061"
export const LOCAL_REGION_PICK_FEE_PRODUCT_NUMBER = "GRS6B2-00066"
export const SPECIAL_PICK_FEE_PRODUCT_NUMBER = "GRS6B2-00067"
export const CROSS_REGION_PICK_FEE_PRODUCT_NUMBER = "GRS6B2-00068"

export const useLoans = () => {
  const resultCount = useRef()
  const [companies, setCompanies] = useState([])
  const fetchData = useGetData("/tw/api/creditcard/get-loan-company")
  const queryData = usePostData("/tw/api/report/loan-data-report")
  const requestData = usePostData("/tw/api/report/loan-data-export")

  const fetchOptions = useGetData(
    useCallback((loanQuery) => {
      return loanQuery
        ? `/tw/api/creditcard/get-loan-contract/${loanQuery.companyId}/${loanQuery.loanAmount}/${loanQuery.scooterNumber}`
        : ""
    }, []),
  )

  const queryOptions = useCallback(
    ({ companyId, loanAmount, scooterNumber }) =>
      fetchOptions({ companyId, loanAmount, scooterNumber })
        .then(handleResponse)
        .then((response) => response.Data),
    [fetchOptions],
  )

  const queryReports = useCallback(
    (query) => {
      return queryData(query)
        .then(handleResponse)
        .then((response) => {
          resultCount.current = response.Data.TotalCount
          return response.Data.List
        })
    },
    [queryData],
  )

  const requestDocument = useCallback(
    (query) => {
      return requestData(query)
        .then(handleResponse)
        .then((response) => response.Data)
    },
    [requestData],
  )

  useEffect(() => {
    fetchData()
      .then(handleResponse)
      .then((response) => setCompanies(response.Data))
  }, [fetchData])

  const defaultLoanCompanyCode = useMemo(() => {
    if (companies.length) return companies[0].Code
  }, [companies])

  return { companies, queryOptions, resultCount, queryReports, requestDocument, defaultLoanCompanyCode }
}

export const useBanks = () => {
  const fetchData = useGetData("/tw/api/utility/get-bank-list")

  const fetchBanks = useCallback(() => {
    return fetchData()
      .then(handleResponse)
      .then((response) => response.Data)
  }, [fetchData])

  return { fetchBanks }
}
